module.exports = __webpack_public_path__ + "static/icons/icon-forecast--white-122ab492464a1fbb99f2e2099bf655a1.svg";